export function StatsStrip({ stats }) {
    if (!stats) return null;
    const items = [
        { label: "Total Classes", value: stats.total_classes },
        { label: "Total Studios", value: stats.total_studios },
        { label: "Categories", value: stats.total_categories },
        { label: "Boroughs Covered", value: stats.total_boroughs },
        { label: "Needs Manual Review", value: stats.manual_review_count },
        { label: "Last Verified", value: stats.last_verified || "—", small: true },
    ];
    return (
        <section className="px-6 md:px-12 py-12 border-t border-border" data-testid="stats-strip">
            <div className="flex items-baseline justify-between mb-8">
                <h2 className="font-display text-3xl sm:text-4xl">
                    Control room <span className="font-editorial text-primary">snapshot.</span>
                </h2>
                <span className="font-mono-label text-xs text-muted-foreground">v1 dataset</span>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-border border border-border">
                {items.map((it) => (
                    <div key={it.label} className="bg-background p-6" data-testid={`stat-${it.label}`}>
                        <div className="font-mono-label text-[10px] text-muted-foreground mb-3">
                            {it.label}
                        </div>
                        <div className={it.small ? "font-display text-xl" : "font-display text-4xl"}>
                            {it.value}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
